export default {
      id: "loadingSpinner-usage",
      viewBox: "0 0 96 96",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#loadingSpinner",
      toString: function () {
        return this.url;
      }
    }